module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_9016.fe7c2957.png";